'use strict';

import { createContext, useContext, useReducer, useEffect } from "react";

export const CartContext = createContext(null);
export const CartDispatchContext = createContext(null);

const cartStorageKey = 'iconStoreCart';

export const CartProvider = ({ children }) => {
  const [cart, dispatch] = useReducer(cartReducer, []);

  useEffect(() => {
    let savedCart = localStorage.getItem(cartStorageKey);
    if (savedCart) {
      savedCart = JSON.parse(savedCart);
      savedCart.items.map((cartItem) => {
        const { nsProductId, nid, icon, name, unitPrice, quantity } = cartItem;
        dispatch({
          type: "ADD_TO_CART",
          nsProductId: nsProductId,
          nid: nid,
          icon: icon,
          name: name,
          unitPrice: unitPrice,
          quantity: quantity,
        });
      });
    }
  }, []);

  return (
    <CartContext.Provider value={cart}>
      <CartDispatchContext.Provider value={dispatch}>
        {children}
      </CartDispatchContext.Provider>
    </CartContext.Provider>
  );
};

function cartReducer(state, action) {
  switch (action.type) {
    case "ADD_TO_CART": {
      localStorage.setItem(
        cartStorageKey,
        JSON.stringify({
          items: [
            ...state,
            {
              nsProductId: action.nsProductId,
              nid: action.nid,
              name: action.name,
              icon: action.icon,
              unitPrice: action.unitPrice,
              quantity: action.quantity,
            }
          ]
        })
      );

      return [
        ...state,
        {
          nsProductId: action.nsProductId,
          nid: action.nid,
          name: action.name,
          icon: action.icon,
          unitPrice: action.unitPrice,
          quantity: action.quantity
        }
      ];
    }
    case "REMOVE_FROM_CART": {
      localStorage.setItem(
        cartStorageKey,
        JSON.stringify({
          items: state.filter((item) => item.nid !== action.nid)
        })
      );
      return state.filter((item) => item.nid !== action.nid);
    }
    case "UPDATE_CART": {
      state = state.map(item => (item.nid === action.nid ? {
          ...item,
          nsProductId: action.nsProductId,
          nid: action.nid,
          name: action.name,
          icon: action.icon,
          unitPrice: action.unitPrice,
          quantity: action.quantity,
          } : item)
      );

      localStorage.setItem(
        cartStorageKey,
        JSON.stringify({
          items: state
        })
      );
      return state;
    }
    default: {
      throw Error("Unknown action: " + action.type);
    }
  }
}

export function useCart() {
  return useContext(CartContext);
}

export function useCartDispatch() {
  return useContext(CartDispatchContext);
}
